export const mergePackageOfferResult = (current, candidate) => {
	if (!candidate) return current || null;
	if (current) throw new Error('Agreement cannot contain multiple Package Offers');
	return candidate;
};

export const usesLegacyAgreementSubmission = (packageOffer) => !packageOffer;

const amount = (value) => Number(value && value.amount != null ? value.amount : 0);

export const applyPackageOfferTokens = (tokens, quote, formatMoney, paymentChoiceLabel = '') => {
	if (!quote) return tokens;
	const result = new Map(tokens);
	const formatted = (money) => formatMoney(amount(money), (money && money.currency) || quote.currency);
	const dueToday = quote.dueToday || {};
	const oneTime = quote.oneTime || {};
	const totals = quote.paymentChoiceTotals || {};
	const recurring = (quote.recurringSchedules || []).reduce((sum, schedule) => ({
		subtotal: sum.subtotal + amount(schedule.subtotal),
		tax: sum.tax + amount(schedule.tax),
		total: sum.total + amount(schedule.amount),
	}), { subtotal: 0, tax: 0, total: 0 });

	result.set('UpFront.Total', formatted(dueToday.total));
	result.set('UpFront.UnformattedTotal', amount(dueToday.total));
	result.set('UpFront.TotalWithoutTax', formatted(dueToday.subtotal));
	result.set('UpFront.Tax', formatted(dueToday.tax));
	result.set('UpFront.CardProcessingFees', formatted(dueToday.cardProcessingFee));
	result.set('UpFront.UnformattedCardProcessingFees', amount(dueToday.cardProcessingFee));
	result.set('UpFront.TotalWithCardProcessingFees', formatted(dueToday.totalWithCardProcessingFee));
	result.set('UpFront.UnformattedTotalWithCardProcessingFees', amount(dueToday.totalWithCardProcessingFee));

	result.set('OneTime.Total', formatted(oneTime.subtotal));
	result.set('OneTime.TotalWithTax', formatted(oneTime.total));
	result.set('OneTime.Tax', formatted(oneTime.tax));
	result.set('Recurring.Total', formatMoney(recurring.subtotal, quote.currency));
	result.set('Recurring.TotalWithTax', formatMoney(recurring.total, quote.currency));
	result.set('Recurring.Tax', formatMoney(recurring.tax, quote.currency));

	result.set('PackageOffer.Total', formatted(totals.total));
	result.set('PackageOffer.TotalWithoutTax', formatted(totals.subtotal));
	result.set('PackageOffer.OriginalTotalWithoutTax', formatted(totals.originalSubtotal));
	result.set('PackageOffer.Tax', formatted(totals.tax));
	result.set('PackageOffer.Discount', formatted(oneTime.discount));
	result.set('PackageOffer.UpFrontTotal', formatted(dueToday.total));
	result.set('PackageOffer.PaymentChoice', paymentChoiceLabel);
	result.set('PackageOffer.Currency', quote.currency || '');

	return result;
};

export const packageOfferPaymentAmount = (tokens, paymentMethodType) => {
	const cardTypes = ['apple_pay', 'google_pay', 'microsoft_pay', 'card'];
	const token = cardTypes.includes(paymentMethodType)
		? 'UpFront.UnformattedTotalWithCardProcessingFees'
		: 'UpFront.UnformattedTotal';
	return Number(tokens.get(token));
};
